import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from "@material-ui/core";
import { Trans, useTranslations } from "adapters/i18n";
import React from "react";
import {
  getWeightEvolutionTableColumns,
  WEIGHT_EVOLUTION_TABLE_COLUMNS,
} from "../arrobaBalanceUtil";
import { BannerAlert } from "features/shared/components";

const ArrobaBalanceWeightEvolutionTable = ({ categoryBalances, classes }) => {
  const { t } = useTranslations();

  const tableColumns = getWeightEvolutionTableColumns(t);

  return (
    <Grid>
      <Typography className={classes.title}>
        {t("animalCategory:weight-evolution-per-category")}
      </Typography>
      <Paper className={classes.tableContainer}>
        <Table id="weight-evolution-table" className={classes.table}>
          <TableHead
            data-testid="weight-evolution-table-header"
            className={classes.tableHeader}
          >
            <TableRow>
              {tableColumns.map((column) => (
                <TableHeaderCell
                  key={column.id}
                  classes={classes}
                  columnId={column.id}
                  label={column.label}
                />
              ))}
            </TableRow>
          </TableHead>
          <TableBody data-testid="weight-evolution-table-body">
            {categoryBalances.map((item) => (
              <TableRow key={item.IdCategoriaAnimal}>
                <TableCell className={classes.tableRowCell}>
                  {item.Nome}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {item.QuantidadeInicial}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {item.PesoInicial}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {item.QuantidadeFinal}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {item.PesoFinal}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <BannerAlert
        className={classes.disclaimer}
        data-testid="table-sum-disclaimer"
        type="info"
      >
        <Trans
          i18nKey="arrobaBalance:weight-sum-disclaimer"
          components={{ bold: <strong /> }}
        />
      </BannerAlert>
    </Grid>
  );
};

const TableHeaderCell = ({ classes, columnId, label }) => {
  const cellClassesMap = {
    [WEIGHT_EVOLUTION_TABLE_COLUMNS.CATEGORY]: classes.headerFirstCell,
    [WEIGHT_EVOLUTION_TABLE_COLUMNS.INITIAL_AMOUNT]: classes.headerCell,
    [WEIGHT_EVOLUTION_TABLE_COLUMNS.WEIGHT_FOR_INITIAL_BALANCE]:
      classes.headerCell,
    [WEIGHT_EVOLUTION_TABLE_COLUMNS.FINAL_AMOUNT]: classes.headerCell,
    [WEIGHT_EVOLUTION_TABLE_COLUMNS.WEIGHT_FOR_FINAL_BALANCE]:
      classes.headerLastCell,
  };

  const cellClass = cellClassesMap[columnId];

  return <TableCell className={cellClass}>{label}</TableCell>;
};

const styles = (theme) => {
  const defaultHeaderCell = {
    color: theme.palette.primary.main,
    padding: "4px 4px",
    fontSize: "14px",
    fontWeight: "500",
    letterSpacing: "1px",
    textAlign: "center",
  };

  return {
    title: {
      fontSize: "20px",
      fontWeight: "bold",
      fontStyle: "medium",
      fontStretch: "medium",
      lineHeight: "medium",
      letterSpacing: "medium",
      color: "#333333",
      marginTop: "40px",
      marginBottom: "20px",
    },
    tableContainer: {
      borderRadius: "16px",
    },
    table: {
      width: "100%",
      fontFamily: "Roboto",
      textAlign: "center",
      borderRadius: "2px",
      padding: "4px 24px 4px 24px",
      fontSize: "14px",
    },
    tableHeader: {
      marginTop: "25px",
      marginBottom: "25px",
      padding: "4px 24px 4px 24px",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      backgroundColor: "#e1e1e1",
    },
    headerFirstCell: {
      ...defaultHeaderCell,
      borderRadius: "16px 0 0 0 ",
    },
    headerCell: {
      ...defaultHeaderCell,
    },
    headerLastCell: {
      ...defaultHeaderCell,
      borderRadius: "0 16px 0 0",
    },
    tableRowCell: {
      color: "#666",
      padding: "4px 24px 4px 24px",
      textAlign: "center",
      fontSize: "14px",
      letterSpacing: "1px",
    },
    disclaimer: {
      marginBottom: "8px",
      marginTop: "12px",
    },
  };
};

export default withStyles(styles)(ArrobaBalanceWeightEvolutionTable);
